import {
	SET_NOTIFICATION,
	UPDATE_NOTIFICATION,
} from './actions';

let defaultState = {};

export default function notification(state = defaultState, action) {
	switch (action.type) {
		case SET_NOTIFICATION:
			return {
				...state,
				latestNotifications: action.data.data.notifications,
				unreadCount: action.data.data.unreadCount,
			}
		case UPDATE_NOTIFICATION:
			return {
				...state,
				latestNotifications: action.data.latestNotifications,
				unreadCount: action.data.unreadCount,
			}
		default:
			return state;
	}
}
